var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-stock")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.product.ComputeStock,
                              label: _vm.$ct("computeStock"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.product.ComputeStock && _vm.advancedStockHandling
            ? _c(
                "w-card",
                { staticClass: "mt" },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("writeOffTitle"))),
                  ]),
                  _c(
                    "w-list",
                    _vm._l(_vm.product.WriteOffProducts, function (item, i) {
                      return _c(
                        "w-list-item",
                        { key: i },
                        [
                          _c("w-list-item-text", [
                            _vm._v(
                              " " +
                                _vm._s(item.Amount) +
                                " x " +
                                _vm._s(item.WriteOffProduct.Sku) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _vm.product.StockID
            ? _c("app-actual-stock", {
                attrs: { id: _vm.product.StockID, product: _vm.product },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }